































































































































import TableComp from '@/components/Common/TableComp.vue';
import TableOperaBtn from '@/components/Common/TableOperaBtn.vue';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { getGearStepListApi } from '@/api/index';
@Component({
  name: 'courseApplicationList',
  components: {
    TableComp,
    TableOperaBtn,
  },
})
export default class extends Vue {
  @Prop({ default: () => [] }) public tableData!: any[];
  @Prop({ default: () => ({}) }) public tablePage!: any[];

  public stepOptions: any[] = [];

  get stepNameIndex() {
    return (stepKey: string) => {
      const options = this.stepOptions;
      if (options.length) {
        return (options.findIndex((item) => Number(stepKey) === item.id))
      }
    }
  }

  public mounted() {
    this.getStepList();
  }

  public getImageUrl(file: string) {
    try {
      return require('@/assets/image/files-icon/' + file + '.png');
    } catch(err) {
      return '';
    }
  }

  public mediaAndAttached(fileList: any) {
    if (fileList && fileList.length > 0) {
      return fileList.map((item: any) => item.typeKey).join(',');
    }
    return '';
  }

  // 获取申请状态下拉
  public async getStepList() {
    const { data } = await getGearStepListApi();
    this.stepOptions = data.datas;
  }

  public handleSizeChange(pageSize: number) {
    this.$emit('page-size-change', pageSize);
  }

  public handleCurrentChange(currentPage: number) {
    this.$emit('page-current-change', currentPage);
  }

  public handleRowClick({ row }: { row: any, column: any}) {
    this.$emit('row-click', row);
  }
  @Emit('do-sort')
  public handleSort(type: string) {
    return type;
  }
}
